
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/olvido-contrasena",
      function () {
        return require("private-next-pages/auth/olvido-contrasena.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/olvido-contrasena"])
      });
    }
  